// extracted by mini-css-extract-plugin
export default {"ReviewsWrapper":"CustomerReviews_ReviewsWrapper__B50BI","sliderWrapper":"CustomerReviews_sliderWrapper__FnJ76"};